exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.instruct[data-v-3eed399e] {\n  padding: 0 0.75rem 0.4rem;\n}\n.instruct .instructionsBox[data-v-3eed399e] {\n  border-radius: 0.4rem;\n  width: 100%;\n  box-shadow: 0 0.1rem 0.4rem 0 rgba(0, 0, 0, 0.08);\n}\n.instruct .circular[data-v-3eed399e] {\n  margin-top: 0.25rem;\n  display: inline-block;\n  width: 0.85rem;\n  line-height: 0.85rem;\n  height: 0.85rem;\n  background: linear-gradient(225deg, #73dacf 0%, #00ab84 100%);\n  border-radius: 100%;\n}", ""]);

// exports
